import { render, staticRenderFns } from "./DocumentLinkComponent.vue?vue&type=template&id=2ed625b9&"
import script from "./DocumentLinkComponent.vue?vue&type=script&lang=js&"
export * from "./DocumentLinkComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports